import { render, staticRenderFns } from "./iconChoose.vue?vue&type=template&id=57d5cf35&"
import script from "./iconChoose.vue?vue&type=script&lang=js&"
export * from "./iconChoose.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports